
import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/UI/button/Button.vue';
import StopDrawing from '@/components/jobDetailed/StopDrawing/StopDrawing.vue';
import TableList from '@/components/UI/TableList.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import LookupSuburb from '@/components/UI/lookups/LookupSuburb.vue';
import { AirRoadBookingStateData, AirRoadJobData } from '@/models/airRoad';
import { getSuburb } from '@/api';
import { AddressBookAirRoadStop, AddressBookEndpointParam, AddressBookResponse } from '@/models/addressBook';
import { fetchGetAddressBookAddresses } from '@/helpers/fetchers';

@Component({
  components: { LookupSuburb, DateTimezoneToggle, TableList, StopDrawing, Button },
})
export default class JobsTable extends Vue {
  @Prop(Boolean) loading!: boolean;
  @Prop(Boolean) dialog!: boolean;
  @Prop(Array) jobsToBook!: Array<AirRoadJobData>;
  @Prop(Object) jobsToBookOriginal!: AirRoadJobData;
  @Prop(Object) bookingState!: AirRoadBookingStateData;

  public addingAddressDefault = {
    id: -1,
    name: '',
    line1: '',
    line2: '',
    line3: null,
    city: '',
    suburb: {
      id: -1,
      name: '',
      state: '',
      postcode: '',
      zone: '',
      status: -1,
    },
    warehouse: false,
    stop_number: 0,
  };
  public addingAddress = { ...this.addingAddressDefault };

  public changedStop = {};
  public addressBook: AddressBookAirRoadStop[];
  public addressBookNames: string[] = [];

  public get nextButtonText(): string {
    return this.bookingState.quickJobs ? 'Book the job' : 'Check delivery address';
  }

  public getAddressBookWrapper(): void {
    const params: AddressBookEndpointParam = {
      username: '',
      customer: '',
      warehouse: true,
      page_size: 100,
      page: 1,
    };
    fetchGetAddressBookAddresses(params).then((res: AddressBookResponse) => {
      this.addressBookNames = [];
      this.addressBook = res.results;
      res.results.forEach((item: AddressBookAirRoadStop) => {
        this.addressBookNames.push(`${item.name}, ${item.suburb.state}`);
      });
    });
  }

  // * Adding new address dialog *
  public openAddressModal(stop_number): void {
    this.dialog = true;
    this.addingAddress.stop_number = stop_number;
  }

  public closeAddressModal(): void {
    this.dialog = false;
    this.addingAddress = { ...this.addingAddressDefault };
  }

  public addAddressBtnClick(): void {
    this.jobsToBook[0].stops[this.addingAddress.stop_number - 1].name = this.addingAddress.name;
    this.jobsToBook[0].stops[this.addingAddress.stop_number - 1].state = this.addingAddress.suburb.state;
    this.jobsToBook[0].stops[this.addingAddress.stop_number - 1].address_line_1 = this.addingAddress.line1;
    this.jobsToBook[0].stops[this.addingAddress.stop_number - 1].address_line_2 = this.addingAddress.line2
      ? this.addingAddress.line2
      : '';
    this.jobsToBook[0].stops[this.addingAddress.stop_number - 1].suburb = this.addingAddress.suburb.name;
    this.jobsToBook[0].stops[this.addingAddress.stop_number - 1].post_code = this.addingAddress.suburb.postcode;
    this.jobsToBook[0].stops[this.addingAddress.stop_number - 1].new = true;
    this.addingAddress = { ...this.addingAddressDefault };
    this.dialog = false;
  }

  public clearChosenAddress(stop_number) {
    this.jobsToBook[0].stops[stop_number - 1].name = this.jobsToBookOriginal.stops[stop_number - 1].name;
    this.jobsToBook[0].stops[stop_number - 1].state = this.jobsToBookOriginal.stops[stop_number - 1].state;
    this.jobsToBook[0].stops[stop_number - 1].address_line_1 =
      this.jobsToBookOriginal.stops[stop_number - 1].address_line_1;
    this.jobsToBook[0].stops[stop_number - 1].address_line_2 = this.jobsToBookOriginal.stops[stop_number - 1]
      .address_line_2
      ? this.jobsToBookOriginal.stops[stop_number - 1].address_line_2
      : '';
    this.jobsToBook[0].stops[stop_number - 1].suburb = this.jobsToBookOriginal.stops[stop_number - 1].name;
    this.jobsToBook[0].stops[stop_number - 1].post_code = String(
      this.jobsToBookOriginal.stops[stop_number - 1].post_code,
    );
    this.jobsToBook[0].stops[stop_number - 1].new = false;
  }

  public changeAddressBook(value, stop, stop_number): void {
    this.changedStop = { ...stop };
    const stopName = value.split(',')[0];
    const stopState = value.split(', ')[1];
    const chosenAddress = this.addressBook.find(x => x.name === stopName && x.suburb.state === stopState);
    const originStop = this.jobsToBookOriginal.stops[stop_number];
    // Address from the Address Book
    if (chosenAddress) {
      this.jobsToBook[0].stops[stop_number].name = chosenAddress.name;
      this.jobsToBook[0].stops[stop_number].state = chosenAddress.suburb.state;
      this.jobsToBook[0].stops[stop_number].address_line_1 = chosenAddress.line1;
      this.jobsToBook[0].stops[stop_number].address_line_2 = chosenAddress.line2 ? chosenAddress.line2 : '';
      this.jobsToBook[0].stops[stop_number].suburb = chosenAddress.suburb.name;
      this.jobsToBook[0].stops[stop_number].post_code = chosenAddress.suburb.postcode;
    }
    // Original address
    if (!chosenAddress && stopName === originStop.name) {
      this.jobsToBook[0].stops[stop_number].name = originStop.name;
      this.jobsToBook[0].stops[stop_number].state = originStop.state;
      this.jobsToBook[0].stops[stop_number].address_line_1 = originStop.address_line_1 ? originStop.address_line_1 : '';
      this.jobsToBook[0].stops[stop_number].address_line_2 = originStop.address_line_2 ? originStop.address_line_2 : '';
      this.jobsToBook[0].stops[stop_number].suburb = originStop.name;
      this.jobsToBook[0].stops[stop_number].post_code = originStop.post_code;
    }
  }

  //   SUBURB LOOKUP
  public changeSuburbLookup(stop, item) {
    this.addingAddress.suburb = { ...item };
  }

  public clearSuburbLookup() {
    this.addingAddress.suburb = { ...this.addingAddressDefault.suburb };
  }

  // updatePagination
  public autocompleteSuburb = getSuburb;

  backBtnClicked() {
    this.$emit('backBtnClicked');
  }

  nextStepClick() {
    this.$emit('nextStepClick');
  }

  // Return address list
  public getAddressOptions(addressBookNames, originalStop) {
    let result: string[] = [...addressBookNames];
    // Original item string
    const originalStopListKey = `${originalStop.name}, ${originalStop.state}`;
    // Add origin if not exist
    if (result.indexOf(originalStopListKey) === -1) {
      result = [...result, originalStopListKey];
    }
    return result;
  }

  private mounted() {
    if (this.addressBookNames.length === 0) {
      this.getAddressBookWrapper();
    }
  }
}
